import React from 'react';


const ReactivityTagIa = ({
                             categoriesInitialized = false,
                             categories = [],
                             currentCategory = {},
                             knnId = null,
                             value = null,
                             updateCategories = ()=>{console.log("updateCategories no defini")}
                         }) => {


    //let categories = [];
    if(categoriesInitialized){
        //categories = categories.filter(category => category._id.toString() !== currentCategory._id.toString());
        if(currentCategory.parents[0].slug === "genre"){
            categories = [
                {
                    _id : "na",
                    title : "N/A"
                },
                ...categories
            ]
        }
    }


    return (
        <select className={"category-select"} onChange={(event) => updateCategories(event.target.value, knnId)}
                value={value}
               >
            {categories.map(category =>(
                <option key={category._id} value={category._id}>{category.title}</option>
            ))}
        </select>
    )

}



export default (ReactivityTagIa);